module.exports = __webpack_public_path__ + "img/img20.a8167d4f.svg";